import { CARD_LIMIT } from './Data';

export const URL_CREATE_WISPETS = '/gamified-rooms';
export const URL_GET_LIST_WISPETS = `/gamified-rooms?is_wispet=true&_limit=${CARD_LIMIT}%(params)s`;
export const URL_GET_DETAIL_WISPETS = `/gamified-rooms/%(id)s`;
export const URL_GET_DETAIL_WISPETS_LEADERBOARD = `/gamified-rooms/%(id)s/players?page=1`;
export const URL_CANCEL_WISPETS = `/gamified-rooms/%(id)s/cancel`;

export const URL_GET_POI = `/point-of-interests?%(params)s`;
export const URL_DETAIL_POI = `/point-of-interests/%(id)s`;
export const URL_POI = `/point-of-interests`;

export const URL_GET_POI_CATEGORIES = `/point-of-interest-categories?%(params)s`;
export const URL_DETAIL_POI_CATEGORIES = `/point-of-interest-categories/%(id)s`;
export const URL_POI_CATEGORIES = `/point-of-interest-categories`;
export const type = {
   CREATE_WISPETS_LOADING: 'CREATE_WISPETS_LOADING',
   CREATE_WISPETS_SUCCESS: 'CREATE_WISPETS_SUCCESS',
   CREATE_WISPETS_FAILED: 'CREATE_WISPETS_FAILED',

   UPDATE_WISPETS_LOADING: 'UPDATE_WISPETS_LOADING',
   UPDATE_WISPETS_SUCCESS: 'UPDATE_WISPETS_SUCCESS',
   UPDATE_WISPETS_FAILED: 'UPDATE_WISPETS_FAILED',

   GET_LIST_WISPETS_LOADING: 'GET_LIST_WISPETS_LOADING',
   GET_LIST_WISPETS_SUCCESS: 'GET_LIST_WISPETS_SUCCESS',
   GET_LIST_WISPETS_FAILED: 'GET_LIST_WISPETS_FAILED',

   GET_DETAIL_WISPETS_LOADING: 'GET_DETAIL_WISPETS_LOADING',
   GET_DETAIL_WISPETS_SUCCESS: 'GET_DETAIL_WISPETS_SUCCESS',
   GET_DETAIL_WISPETS_FAILED: 'GET_DETAIL_WISPETS_FAILED',

   GET_DETAIL_WISPETS_LEADERBOARD_LOADING:
      'GET_DETAIL_WISPETS_LEADERBOARD_LOADING',
   GET_DETAIL_WISPETS_LEADERBOARD_SUCCESS:
      'GET_DETAIL_WISPETS_LEADERBOARD_SUCCESS',
   GET_DETAIL_WISPETS_LEADERBOARD_FAILED:
      'GET_DETAIL_WISPETS_LEADERBOARD_FAILED',

   CANCEL_WISPETS_LOADING: 'CANCEL_WISPETS_LOADING',
   CANCEL_WISPETS_SUCCESS: 'CANCEL_WISPETS_SUCCESS',
   CANCEL_WISPETS_FAILED: 'CANCEL_WISPETS_FAILED',

   GET_POI_LOADING: 'GET_POI_LOADING',
   GET_POI_SUCCESS: 'GET_POI_SUCCESS',
   GET_POI_FAILED: 'GET_POI_FAILED',

   SHOW_BRAND_LOADING: 'SHOW_BRAND_LOADING',
   SHOW_BRAND_SUCCESS: 'SHOW_BRAND_SUCCESS',
   SHOW_BRAND_FAILED: 'SHOW_BRAND_FAILED',

   CREATE_POI_LOADING: 'CREATE_POI_LOADING',
   CREATE_POI_SUCCESS: 'CREATE_POI_SUCCESS',
   CREATE_POI_FAILED: 'CREATE_POI_FAILED',

   DELETE_POI_LOADING: 'DELETE_POI_LOADING',
   DELETE_POI_SUCCESS: 'DELETE_POI_SUCCESS',
   DELETE_POI_FAILED: 'DELETE_POI_FAILED',

   UPDATE_POI_LOADING: 'UPDATE_POI_LOADING',
   UPDATE_POI_SUCCESS: 'UPDATE_POI_SUCCESS',
   UPDATE_POI_FAILED: 'UPDATE_POI_FAILED',

   GET_CATEGORY_LOADING: 'GET_CATEGORY_LOADING',
   GET_CATEGORY_SUCCESS: 'GET_CATEGORY_SUCCESS',
   GET_CATEGORY_FAILED: 'GET_CATEGORY_FAILED',

   SHOW_POI_CATEGORY_LOADING: 'SHOW_POI_CATEGORY_LOADING',
   SHOW_POI_CATEGORY_SUCCESS: 'SHOW_POI_CATEGORY_SUCCESS',
   SHOW_POI_CATEGORY_FAILED: 'SHOW_POI_CATEGORY_FAILED',

   CREATE_POI_CATEGORY_LOADING: 'CREATE_POI_CATEGORY_LOADING',
   CREATE_POI_CATEGORY_SUCCESS: 'CREATE_POI_CATEGORY_SUCCESS',
   CREATE_POI_CATEGORY_FAILED: 'CREATE_POI_CATEGORY_FAILED',

   DELETE_POI_CATEGORY_LOADING: 'DELETE_POI_CATEGORY_LOADING',
   DELETE_POI_CATEGORY_SUCCESS: 'DELETE_POI_CATEGORY_SUCCESS',
   DELETE_POI_CATEGORY_FAILED: 'DELETE_POI_CATEGORY_FAILED',

   UPDATE_POI_CATEGORY_LOADING: 'UPDATE_POI_CATEGORY_LOADING',
   UPDATE_POI_CATEGORY_SUCCESS: 'UPDATE_POI_CATEGORY_SUCCESS',
   UPDATE_POI_CATEGORY_FAILED: 'UPDATE_POI_CATEGORY_FAILED',
};

export const statusMapRoom = {
   WAITING_PLAYER: 'Menunggu Pemain',
   CANCELED: 'Dibatalkan',
   FINISHED: 'Selesai',
   WAITING_PAYMENT: 'Menunggu Pembayaran',
   PLAYING: 'Bermain',
};
